module.exports = __webpack_public_path__ + "img/sectorisation_geographique.b541475b.png";